import React, { useState, useEffect } from 'react';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import equipamentosDetalhes from './Data';

const Equipamento = () => {
  const location = useLocation();
  const { nome } = useParams();
  const navigate = useNavigate();
  
  const produto = location.state || { nome: decodeURIComponent(nome), imagem: '' };
  const detalhes = equipamentosDetalhes[produto.nome] || {};

  const [dimensoesOpen, setDimensoesOpen] = useState(true);
  const [caracteristicasOpen, setCaracteristicasOpen] = useState(true);
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      
      <Navbar theme="light" />
      
      {/* Reduzido o px-6 para px-4 no mobile para ganhar espaço lateral */}
      <main className="flex-grow container mx-auto px-4 sm:px-6 md:px-12 py-8 md:py-12 pt-28 lg:pt-32">
        <div className="bg-white rounded-2xl md:rounded-3xl shadow-xl overflow-hidden border border-gray-100">
          <div className="flex flex-col lg:flex-row">
            
            {/* Left Column: Media - Reduzido o p-8 para p-5 no mobile */}
            <div className="w-full lg:w-1/2 p-5 sm:p-8 lg:p-12 bg-white flex flex-col justify-start border-b lg:border-b-0 lg:border-r border-gray-100">
              
              {/* Título Mobile Reduzido para text-2xl */}
              <h1 className="text-2xl sm:text-3xl font-black text-usifresa-blue mb-6 leading-tight lg:hidden">
                {produto.nome}
              </h1>
              
              <Swiper
                modules={[Navigation, Autoplay, Pagination]}
                navigation
                pagination={{ clickable: true }}
                spaceBetween={30}
                slidesPerView={1}
                autoplay={{ delay: 4000, disableOnInteraction: false }}
                // Reduzido o padding interno do carrossel no mobile (p-2)
                className="w-full rounded-2xl bg-gray-50 aspect-video flex items-center justify-center p-2 sm:p-4 md:p-8"
              >
                {(detalhes.imagens || [produto.imagem]).map((img, idx) => (
                  <SwiperSlide key={idx} className="flex items-center justify-center w-full h-full">
                    <img src={img} alt={produto.nome} className="max-w-full max-h-[100%] object-contain drop-shadow-md" />
                  </SwiperSlide>
                ))}
              </Swiper>

              {detalhes.videos && detalhes.videos.length > 0 && (
                <div className="mt-6 md:mt-8 space-y-4">
                  <h4 className="font-semibold text-gray-500 uppercase tracking-wider text-xs md:text-sm mb-3 md:mb-4">Vídeos Demonstrativos</h4>
                  {detalhes.videos.map((url, idx) => (
                    <div key={idx} className="aspect-video rounded-xl overflow-hidden shadow-md">
                      <iframe
                        src={url}
                        title={`Video ${idx + 1}`}
                        className="w-full h-full"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Right Column: Details - Reduzido o p-8 para p-5 no mobile */}
            <div className="w-full lg:w-1/2 p-5 sm:p-8 lg:p-12 bg-gray-50 flex flex-col">
              <h1 className="hidden lg:block text-4xl font-bold text-usifresa-blue mb-8">{produto.nome}</h1>
              
              <div className="flex-grow space-y-4 md:space-y-6">
                {/* Dimensões */}
                {detalhes.dimensoes && detalhes.dimensoes.length > 0 && (
                  <div className="bg-white rounded-xl md:rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
                    <button 
                      onClick={() => setDimensoesOpen(!dimensoesOpen)}
                      className="w-full px-5 py-4 flex justify-between items-center bg-white hover:bg-gray-50 transition-colors"
                    >
                      <span className="font-bold text-usifresa-blue text-sm md:text-base tracking-wide">DIMENSÕES</span>
                      <svg className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${dimensoesOpen ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    </button>
                    {dimensoesOpen && (
                      <div className="px-5 pb-5 border-t border-gray-100 pt-4 space-y-3">
                        {detalhes.dimensoes.map((d, i) => (
                          <div key={i} className="flex items-start gap-3 text-gray-600 text-sm md:text-base">
                            <div className="mt-1.5 w-1.5 h-1.5 rounded-full bg-usifresa-orange shrink-0"></div>
                            <span>{d}</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}

                {/* Características Técnicas */}
                {detalhes.caracteristicas && detalhes.caracteristicas.length > 0 && (
                  <div className="bg-white rounded-xl md:rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
                    <button 
                      onClick={() => setCaracteristicasOpen(!caracteristicasOpen)}
                      className="w-full px-5 py-4 flex justify-between items-center bg-white hover:bg-gray-50 transition-colors"
                    >
                      <span className="font-bold text-usifresa-blue text-sm md:text-base tracking-wide text-left">CARACTERÍSTICAS TÉCNICAS</span>
                      <svg className={`w-5 h-5 text-gray-500 shrink-0 transition-transform duration-300 ${caracteristicasOpen ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    </button>
                    {caracteristicasOpen && (
                      <div className="px-5 pb-5 border-t border-gray-100 pt-4 space-y-3">
                        {detalhes.caracteristicas.map((c, i) => (
                          <div key={i} className="flex items-start gap-3 text-gray-600 text-sm md:text-base">
                            <div className="mt-1.5 w-1.5 h-1.5 rounded-full bg-usifresa-orange shrink-0"></div>
                            <span>{c}</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </div>

              {/* Action Buttons - Gaps e Paddings otimizados para mobile */}
              <div className="mt-8 md:mt-12 pt-6 md:pt-8 border-t border-gray-200 flex flex-col sm:flex-row flex-wrap gap-3 md:gap-4">
                {detalhes.catalogo && (
                  <a
                    href={detalhes.catalogo}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex-1 min-w-[200px] flex items-center justify-center gap-2 px-4 py-3.5 md:py-4 bg-gray-200 hover:bg-gray-300 text-gray-800 text-sm md:text-base font-bold rounded-xl transition-colors"
                  >
                    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>
                    Catálogo
                  </a>
                )}
                
                <button
                  onClick={() => navigate('/contato')}
                  className="flex-1 min-w-[200px] px-4 py-3.5 md:py-4 bg-usifresa-blue hover:bg-[#0a3861] text-white text-sm md:text-base font-bold rounded-xl shadow-lg transition-colors"
                >
                  Solicite um orçamento
                </button>
                
                <a
                  href={detalhes.whatsapp || "https://wa.me/5516992282079"}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-[2] min-w-[250px] flex items-center justify-center gap-2 px-4 py-3.5 md:py-4 bg-[#25D366] hover:bg-[#20b858] text-white text-sm md:text-base font-bold rounded-xl shadow-[0_4px_14px_0_rgba(37,211,102,0.39)] hover:shadow-[0_6px_20px_rgba(37,211,102,0.23)] hover:-translate-y-1 transition-all"
                >
                  <svg className="w-5 h-5 md:w-6 md:h-6 fill-current" viewBox="0 0 32 32"><path d="M16 2.933A13.067 13.067 0 0 0 4.267 24.56l-1.334 4.8a2.133 2.133 0 0 0 2.613 2.613l4.8-1.334A13.067 13.067 0 1 0 16 2.933Zm0 23.467a10.4 10.4 0 0 1-5.36-1.547l-.373-.227-5.6 1.56 1.56-5.6-.227-.373A10.4 10.4 0 1 1 16 26.4Zm5.36-7.36c-.293-.147-1.733-.867-2-1.013-.267-.16-.467-.213-.667.08-.2.293-.773.96-.947 1.16-.173.2-.347.213-.64.067-.293-.147-1.24-.457-2.36-1.453-.873-.747-1.467-1.667-1.64-1.96-.173-.293-.02-.453.127-.6.133-.133.293-.347.44-.52.147-.173.2-.293.307-.48.107-.187.053-.36-.013-.507-.067-.147-.667-1.6-.92-2.2-.24-.573-.48-.493-.667-.507-.173-.013-.373-.013-.573-.013-.2 0-.52.08-.8.373-.28.293-1.067 1.04-1.067 2.533 0 1.493 1.093 2.933 1.24 3.133.147.2 2.16 3.307 5.227 4.493.733.307 1.307.493 1.76.627.74.236 1.413.203 1.947.123.593-.087 1.733-.707 1.98-1.387.24-.68.24-1.267.173-1.387-.067-.12-.267-.187-.56-.333Z"/></svg>
                  Chame no WhatsApp
                </a>
              </div>

            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Equipamento;